import * as React from 'react';

export interface ISettingBoxLayout {
    title?: string;
    hasError?: boolean;
    children: React.ReactNode;
    onClose?: (event?: any) => void;
}

const SettingBoxLayout: React.SFC<ISettingBoxLayout> = (props) => (
    <SettingBox>
        <SettingHeader {...props} />
        <SettingBody>{props.children}</SettingBody>
    </SettingBox>
);

const SettingBox: React.SFC<{ children: React.ReactNode }> = (props) => (
    <div className="setting-box">{props.children}</div>
);

const SettingHeader: React.SFC<Partial<ISettingBoxLayout>> = ({
    title,
    hasError = false,
    onClose
}) => (
    <div className="setting-box--header">
        {title || '&nbsp;'}
        {/* {(!hasError && <i className="nx nx-close" onClick={onClose} />) || null} */}
    </div>
);

const SettingBody: React.SFC<{ children: React.ReactNode }> = (props) => (
    <div className="setting-box--body">{props.children}</div>
);

const SettingFooter: React.SFC<{ children: React.ReactNode }> = (props) => (
    <div className="setting-box--footer">{props.children}</div>
);

const SettingGroupRow: React.SFC<{ children: React.ReactNode }> = (props) => (
    <div className="setting-group-row">{props.children}</div>
);

const SettingGroup: React.SFC<{
    children: React.ReactNode;
    label: string;
}> = (props) => (
    <div className="setting-group">
        <label className="setting-group--label">{props.label}</label>
        <div className="setting-group--form-element">{props.children}</div>
    </div>
);

export {
    SettingBody,
    SettingBox,
    SettingBoxLayout,
    SettingFooter,
    SettingHeader,
    SettingGroupRow,
    SettingGroup
};

export default SettingBoxLayout;
